import * as React from 'react';
import styled from 'styled-components';
import {lighten} from 'polished';
import {transition} from 'helpers/css';
import outline from 'helpers/outline';
import {RouteName} from "router/routes";
import {navigateTo} from "helpers/navigate-to";
import {Theme} from '../../../../../../../stores/AppStore';

export interface ControlButtonProps {
  routeName: RouteName;
  href?: string;
  children: React.ReactNode | React.ReactNodeArray;
}

export const Container = styled.a`
  justify-content: center;
  align-items: center;
  display: grid;
  padding: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  ${transition()};
  
  &:hover,
  &:focus-visible {
    background-color: ${({theme}) => `
      ${lighten(.03, theme.variables.backgroundColor)};
    `};
  }
  
  &:active {
    background-color: ${({theme}) => `
      ${lighten(.08, theme.variables.backgroundColor)};
    `};
  }
  
  &:focus-visible {
    ${outline(4, 1)};
  }

  background: ${({theme}) => theme.name === Theme.Light && theme.variables.backgroundColor};
`;

/**
 * This component renders a button inside the menu ite,.
 * @param {React.AnchorHTMLAttributes<HTMLAnchorElement>} props
 * @return {React.ReactElement<React.AnchorHTMLAttributes<HTMLAnchorElement>>}
 * @constructor
 */
export default function ControlButton(
    props: ControlButtonProps,
): React.ReactElement<React.AnchorHTMLAttributes<HTMLAnchorElement>> {

  function handleNavigate(e: React.MouseEvent) {
    e.preventDefault();
    navigateTo(props.routeName)
  }

  return (
    <Container
      href={props.href}
      onClick={handleNavigate}
    >
      {props.children}
    </Container>
  );
}
